import Vue from 'vue'
import Router from 'vue-router'
import UsersTable from '@/components/users/UsersTable'
import Users from '@/components/users/Users'
import User from '@/components/users/User'
import ProjectDetails from '@/components/projects/ProjectDetails'
import ProjectTable from '@/components/projects/ProjectsTable'
import Projects from '@/components/projects/Projects'
import Project from '@/components/projects/Project'
import CustomReports from '@/components/customReports/CustomReports'
import AmaalaDailyDigest from '@/components/customReports/AmaalaDailyDigest'
import AmaalaWeeklyReport from '@/components/customReports/AmaalaWeeklyReport'
import RolesTable from '@/components/roles/RolesTable'
import Roles from '@/components/roles/Roles'
import Role from '@/components/roles/Role'
import GnipRulesTable from '@/components/gnipRules/GnipRulesTable'
import GnipRules from '@/components/gnipRules/GnipRules'
import Login from '@/components/Login'
import Home from '@/components/Home'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '',
      component: Home
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/projects',
      component: Projects,
      children: [
        {path: '', component: ProjectTable},
        {path: 'new', component: Project},
        {path: ':id', component: Project, props: true},
        {path: 'details/:id', component: ProjectDetails, props: true}
      ]
    },
    {
      path: '/custom-reports',
      name: 'CustomReports',
      component: CustomReports
    },
    {
      path: '/amaala-daily-digest',
      name: 'AmaalaDailyDigest',
      component: AmaalaDailyDigest
    },
    {
      path: '/amaala-weekly-report',
      name: 'AmaalaWeeklyReport',
      component: AmaalaWeeklyReport
    },
    {
      path: '/users',
      component: Users,
      children: [
        {path: '', component: UsersTable},
        {path: 'new', component: User},
        {path: ':id', component: User, props: true}
      ]
    },
    {
      path: '/roles',
      component: Roles,
      children: [
        {path: '', component: RolesTable},
        {path: 'new', component: Role},
        {path: ':id', component: Role, props: true}
      ]
    },
    {
      path: '/gnipRules',
      component: GnipRules,
      children: [
        {path: '', component: GnipRulesTable}
      ]
    },
    {
      path: '*',
      redirect: '/login'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js